(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/prolong-game-hybrid.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/prolong-game-hybrid.js');

'use strict';

const {
  useRef
} = React;
const {
  context: {
    ProlongProvider
  },
  components: {
    ProlongBottomSheet
  }
} = svs.numbergames.prolong_game;

const ProlongGameHybrid = _ref => {
  let {
    wager,
    onOpenClose,
    trackingCategory,
    onSuccessCb,
    onDoneCb,
    onCancelCb,
    getAfterChangeReturnUrl,
    onboardingWidgetArea
  } = _ref;
  const lastStateRef = useRef(null);
  const handleStateChange = _ref2 => {
    let {
      state
    } = _ref2;
    if (state === lastStateRef.current) return;
    lastStateRef.current = state;
    const isExpanded = state === 'expanded';
    onOpenClose({
      isOpen: isExpanded
    });
    svs.components.analytics.trackEvent({
      category: 'bottom sheet',
      action: isExpanded ? 'prolong_reminderOpen' : 'prolong_reminderClose',
      opt_label: wager.productName
    });
  };
  return React.createElement(ProlongProvider, {
    wager: wager,
    trackingCategory: trackingCategory,
    onSuccessCb: onSuccessCb,
    onDoneCb: onDoneCb,
    onCancelCb: onCancelCb,
    getAfterChangeReturnUrl: getAfterChangeReturnUrl,
    onboardingWidgetArea: onboardingWidgetArea
  }, React.createElement("div", {
    className: "prolong-game-container"
  }, React.createElement(ProlongBottomSheet, {
    behavior: "hybrid",
    isExpanded: true,
    headerTitle: "Spelet \xE4r slut - f\xF6rl\xE4ng",
    onStateChange: handleStateChange
  })));
};
setGlobal('svs.numbergames.prolong_game.ProlongGameHybrid', ProlongGameHybrid);

 })(window);